import styled from 'styled-components';

const FormPadre = styled.div``;

const FormMadre = styled.div``;

const FormHermanos = styled.div``;

const FormSituacionFam = styled.div`
  margin-top: 16px;
`;

const FormConyuge = styled.div``;

const FormApoderados = styled.div``;

const SeparationLine = styled.div`
  width: 100%;
  height: 4px;
  background: var(--background-background-disabled);
  margin-bottom: 24px;
  margin-top: 24px;
`;

export {
  FormPadre,
  FormMadre,
  FormHermanos,
  FormSituacionFam,
  FormApoderados,
  FormConyuge,
  SeparationLine
};
